import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  AnzFeaturedPartner,
  AnzHomePageService,
} from '../../services/anz-home-page.service';

@Component({
  selector: 'rd-anz-featured-partners',
  templateUrl: './featured-partners.component.html',
  styleUrls: ['./featured-partners.component.scss'],
})
export class AnzFeaturedPartnersComponent implements OnInit {
  partners: Partial<AnzFeaturedPartner>[];
  isLoading$ = new BehaviorSubject(true);
  constructor(private anzHomePageService: AnzHomePageService) {}

  ngOnInit(): void {
    this.anzHomePageService.getFeaturedPartnerApiData().subscribe((data) => {
      this.isLoading$.next(false);
      if (data.length) {
        this.partners = data;
      }
    });
  }
}
